import Vue from 'vue';
import { cloneCalendar } from './functions';
import { calculateAcrRange, mergeCalendar } from './analytics';
import Workout from '../../lib/workout/Workout';
import ActivityElement from '../../lib/workout/ActivityElement';

export const plannerCalendarState = {
  plannerCalendar: null,
  plannedWorkout: null,
  mergedCalendar: [],
};

export const plannerCalendarGetters = {
  localCalendarCopy: (state, getters) => cloneCalendar(getters.calendarCopy),
  plannerCalendar: (state, getters) => {
    let workout = getters.plannedWorkout;
    if (!workout) {
      workout = new Workout();
      workout.planDefinition.push(new ActivityElement());
    }
    const ret = cloneCalendar(
      getters.calendarCopy.filter(
        d => d.date.isSameOrAfter(
          workout.localStartTime.clone().subtract(28, 'days'),
        ),
      ),
    );
    const day = ret.find(d => d.date.isSame(workout.localStartTime, 'day'));
    const existingWorkout = (day.workouts || [])
      .find(w => w.trainingPlanId === workout.trainingPlanId);
    if (existingWorkout) {
      day.plannedDistance -= existingWorkout.getEstimatedDistance();
      day.plannedWeightedLoad -= existingWorkout.getEstimatedLoad();
      day.plannedDuration -= existingWorkout.getEstimatedDuration();
    }
    day.plannedDistance = (day.plannedDistance || 0) + workout.getEstimatedDistance();
    day.plannedWeightedLoad = (day.plannedWeightedLoad || 0) + workout.getEstimatedLoad();
    day.plannedDuration = (day.plannedDuration || 0) + workout.getEstimatedDuration();
    return calculateAcrRange(day.date.clone(), true, ret);
  },
  mergedCalendar: (state, getters) => {
    const ret = mergeCalendar(
      getters.localCalendarCopy,
      getters.plannerCalendar,
    )
      .map(d => ({
        date: d.date,
        distance: d.distance,
        plannedDistance: d.plannedDistance,
        weightedLoad: d.weightedLoad,
        plannedWeightedLoad: d.plannedWeightedLoad,
        ebAcrPw: d.ebAcrPw,
        ebChronicLoad: d.ebChronicLoad,
        duration: d.duration || 0,
        plannedDuration: d.plannedDuration || 0,
        numActivities: d.numActivities,
        numWorkouts: d.numWorkouts,
      }));
    return ret;
  },
  plannedWorkout: state => state.plannedWorkout,
};

export const plannerCalendarMutations = {
  setPlannedWorkout(state, workout) {
    Vue.set(state, 'plannedWorkout', workout);
  },
};

export const plannerCalendarActions = {
  setPlannedWorkout(context, workout) {
    context.commit('setPlannedWorkout', workout);
  },
};
